module.exports = __webpack_public_path__ + "cd20c9b210a915b3a888af2199000f28.png";